import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components/macro'

import { Breadcrumbs, Layout } from '@loadsmart/loadsmart-ui'

import { user } from 'legacy/utils/user'

import { type Carrier } from '../domain/Carrier'
import { type Shipper } from '../domain/Shipper'
import { CarrierInformation } from './CarrierInformation'

const StyledBreadcrumbs = styled(Breadcrumbs)`
  align-items: center;
`

export type SpotQuotePageHeaderProps = {
  shipper: Shipper
  carrier?: Carrier
}

export function SpotQuotePageHeader({ shipper, carrier }: SpotQuotePageHeaderProps) {
  const { push: navigate } = useHistory()
  const shouldDisplayBreadcrumbs = user.isLoggedIn()

  const handleBackToLoadboard = useCallback(() => {
    navigate(`/all-in-one/bids-list/`)
  }, [navigate])

  const breadcrumbEntries = useMemo(
    () => [
      {
        label: 'Bids',
        onClick: handleBackToLoadboard,
        url: '#/all-in-one/bids-list/',
      },
      { label: `${shipper.companyName}'s Bid Invitation` },
    ],
    [shipper.companyName, handleBackToLoadboard]
  )

  return (
    <Layout.Group justify={'space-between'} align="center">
      <div>
        {shouldDisplayBreadcrumbs && (
          <StyledBreadcrumbs onBack={handleBackToLoadboard} entries={breadcrumbEntries} />
        )}
      </div>
      {carrier && <CarrierInformation carrier={carrier} />}
    </Layout.Group>
  )
}
